export const CAMPAIGN_STATUS_COLORS: Record<
  string,
  { bg: string; text: string }
> = {
  PLANNING: { bg: 'campaignStatusGroups.planning', text: 'graphite.500' },
  ONGOING: { bg: 'campaignStatusGroups.ongoing', text: 'graphite.500' },
  IN_SETTLEMENT: { bg: 'campaignStatusGroups.in_settlement', text: 'white' },
  SETTLED: { bg: 'campaignStatusGroups.settled', text: 'white' },
};
